interface GetDomainParams {
  email?: string;
}

const getDomain = ({ email }: GetDomainParams): string | undefined => {
  const matches = email?.match(/^.*@(.*)$/);

  if (matches) {
    return matches[1];
  }

  return email;
};

export default getDomain;
